import { UserComponent } from '@craftjs/core';
import { FormFieldWithOptionsProps, FormFieldWithScoreProps } from './BaseControlTypes';
import { createId } from 'src/helpers/typeUtils';

export type FormDropdownInputProps = FormFieldWithOptionsProps &
  FormFieldWithScoreProps & {
    suggestion?: boolean;
    placeholder?: string;
  };

export const formDropdownInputDefaultProps: FormDropdownInputProps = {
  title: 'Dropdown',
  dataKey: createId(),
  options: [
    {
      key: createId(),
      value: 'Option 1',
    },
    {
      key: createId(),
      value: 'Option 2',
    },
  ],
};

export const formMultipleDropdownInputDefaultProps: FormDropdownInputProps = {
  title: 'Dropdown multiselect',
  dataKey: createId(),
  options: [
    {
      key: createId(),
      value: 'Option 1',
    },
    {
      key: createId(),
      value: 'Option 2',
    },
  ],
};

export type FormDropdownInputComponent = UserComponent<FormDropdownInputProps>;
